import { firebaseInit } from '@/firebase'
import { acceptHMRUpdate, createPinia, StoreDefinition } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import { ClickOutsideDirective, MousedownOutsideDirective, WheelOutsideDirective } from './directives/ActionOutsideDirective'
import router from './router'
import AuthService from '@/services/AuthService'
import { useDefaultStore } from './store/index.js'
import { useEditingSessionsStore } from './store/editingSessionsStore.js'
import { useProductsStore } from './store/productsArchiveStore.js'
import { useProductsBulkStore } from './store/productsBulkStore.js'
import { useProductsTableUtilityStore } from './store/productsTableUtilityStore.js'
import { useProductsViewStore } from './store/productsViewStore.js'
import { usePropertyStore } from './store/propertyStore.js'
import { useTaxonomiesStore } from './store/taxonomiesStore.js'
import { useTaxonomyToolStore } from './store/taxonomyToolStore.js'

export const setupApp = async () => {
  const app = createApp(App)
    .use(createPinia())
    .use(router)
    .directive('click-outside', ClickOutsideDirective)
    .directive('mousedown-outside', MousedownOutsideDirective)
    .directive('wheel-outside', WheelOutsideDirective)

  // enable hot module reload for pinia
  const stores: StoreDefinition[] = [
    useEditingSessionsStore,
    useDefaultStore,
    useProductsStore,
    useProductsBulkStore,
    useProductsTableUtilityStore,
    useProductsViewStore,
    usePropertyStore,
    useTaxonomiesStore,
    useTaxonomyToolStore,
  ]

  stores.forEach((store) => {
    import.meta.hot?.accept(acceptHMRUpdate(store, import.meta.hot))
  })

  await firebaseInit()
  AuthService.init()

  return app
}
